import { motion } from "framer-motion";

const engines = [
  {
    id: "engine-defense",
    num: "01",
    title: "Defense Tech",
    desc: "Advanced systems and software that give defenders a decisive edge.",
    img: "/defense-tech.png",
    span: "lg:col-span-7 lg:row-span-2",
    tall: true,
  },
  {
    id: "engine-health",
    num: "02",
    title: "Managed Health",
    desc: "Digital health operations that improve outcomes and lower cost.",
    img: "/managed-health.png",
    span: "lg:col-span-5",
  },
  {
    id: "engine-cyber",
    num: "03",
    title: "Digital Infrastructure & Cyber",
    desc: "Secure, resilient infrastructure for an always-on world.",
    img: "https://images.unsplash.com/photo-1680992046626-418f7e910589?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxzZXJ2ZXIlMjByb29tJTIwYmx1ZSUyMGxpZ2h0fGVufDB8fHx8MTc4ODEyODEzMXww&ixlib=rb-4.1.0&q=85",
    span: "lg:col-span-5",
  },
  {
    id: "engine-energy",
    num: "04",
    title: "Energy Resilience",
    desc: "Modern, hardened energy systems built for continuity.",
    img: "https://images.unsplash.com/photo-1613665813446-82a78c468a1d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwxfHxzb2xhciUyMHBhbmVscyUyMHN1bnNldHxlbnwwfHx8fDE3ODgxMjgxMzF8MA&ixlib=rb-4.1.0&q=85",
    span: "lg:col-span-6",
  },
  {
    id: "engine-software",
    num: "05",
    title: "Mission Software",
    desc: "Software factories that ship secure capability at mission speed.",
    img: "/mission-software.png",
    span: "lg:col-span-6",
  },
];

export const Business = () => (
  <section id="business" data-testid="business-section" className="py-24 md:py-32 px-6 md:px-12 border-t border-black/10">
    <div className="max-w-7xl mx-auto">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ type: "spring", stiffness: 60, damping: 18 }}
        className="max-w-3xl"
      >
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#0891B2] mb-4">Our Business</p>
        <h2 className="text-3xl sm:text-4xl font-heading font-bold tracking-tight text-zinc-950">
          Five growth engines, one 2030 strategy
        </h2>
        <p className="mt-6 text-[19px] leading-relaxed text-zinc-600">
          Our business sectors deliver mission-driven, technology-forward
          expertise aligned to our 2030 strategy.
        </p>
      </motion.div>

      <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-6 md:gap-8">
        {engines.map((e, i) => (
          <motion.div
            key={e.id}
            data-testid={e.id}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ type: "spring", stiffness: 60, damping: 18, delay: i * 0.08 }}
            className={`group relative overflow-hidden bg-[#D4D4D8] border border-black/10 hover:border-black/30 hover:-translate-y-1 transition-all duration-300 ${e.span} ${e.tall ? "min-h-[420px] lg:min-h-[560px]" : "min-h-[340px] lg:min-h-[360px]"}`}
          >
            {e.img && (
              <>
                <img
                  src={e.img}
                  alt={e.title}
                  className="absolute inset-0 w-full h-full object-cover opacity-90 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500"
                />
                <div className={`absolute inset-x-0 bottom-0 ${e.tall ? "h-[35%]" : "h-[65%]"} bg-gradient-to-t from-[#D4D4D8] via-[#D4D4D8] via-70% to-transparent`} />
              </>
            )}
            <div className="relative h-full flex flex-col justify-end p-8 md:p-10">
              <p className="font-mono text-sm text-[#0891B2] mb-3">{e.num} /</p>
              <h3 className="text-3xl sm:text-4xl font-heading font-bold tracking-tight text-zinc-950">{e.title}</h3>
              <p className="mt-2 text-[19px] leading-relaxed text-zinc-600 max-w-md">{e.desc}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
